import { gql } from '@apollo/client'

export default gql`
  query GetCurrentBattlePassKeyBalance {
    getCurrentBattlePassKeyBalance {
      items {
        balance
        keyAssetName
      }
    }
  }
`
